import { LessonService, PortfolioService, ContentService } from '@DavisDigital/davisdigitalfrontend.module';
import { Lesson, Portfolio, Folder, FolderTypes, FoldersAPIResponse } from '@DavisDigital/interfaces';

class DuplicateModalState {
	public isLoading = false;
	public title: string;
    
    public showCreateNewFolder: boolean;
    public newFolderName: string;
	
	public hasError = false;
	public hasSuccess = false;
	public message: string;
	
	public showConfirmDialog = false;
	public confirmMessage: string;

	public folders: Folder[] = undefined;
	public selectedFolder: Folder = undefined;


    public  newLessonOrPortfolioURL: string;

	public setLoading = (isLoading: boolean) => {
		this.isLoading = isLoading;
	};
	
	public setError = (error=false, message ?: string) => {
		this.hasError = error;
	    this.message = message;
		if(this.hasError){
		    this.hasSuccess = false;
		}
	};
	
	public setSuccess = (success=false, message ?: string) => {
		this.hasSuccess = success;
	    this.message = message;
		if(this.hasSuccess){
		    this.hasError = false;
		}
	};
	
	public setShowConfirmDialog = (showConfirmDialog: boolean, confirmMessage ?: string) => {
		this.showConfirmDialog = showConfirmDialog;
		this.confirmMessage = confirmMessage;
	};

	public setFolders = (folders: Folder[]) => {
		this.folders = folders;
	};
}


class DuplicateModalController {
    
    private close:Function; //injected from modal-service
    
    public lesson : Lesson;
    public portfolio: Portfolio;
    public actionType: string;
    public accountType: string;
    
    public shareRequiredForStudent: boolean = false;

    private myFolders = [];
	
    public state$: DuplicateModalState;
	public districtAccounts:Array<any> = [];
	public portfolioFacultyAccount:string = "";
	
	// @ngInject
	constructor( 
	    private $log                : ng.ILogService,
	    private lessonService       : LessonService,
	    private portfolioService    : PortfolioService,
	    private contentService      : ContentService,
	){
	    this.state$ = new DuplicateModalState();
	}
	
	public $onInit = () => {
	    this.state$.setLoading(true);
	    
	    this.state$.title = `Copy - ${this.lesson?.title || this.portfolio?.title}`
		
		console.log("action Type", this.actionType, this.accountType, this.state$.title);
		
	    this.getMyFolders()
	    .then( (res) => {
    		if (!res?.data?.records) { throw res;}
    		this.state$.setFolders(res?.data?.records);
    	})
	    .catch( e => {
	        this.$log.error(e);
	        this.state$.setError(true, e?.message || e?.data?.message || "Unable to fetch folders, Something went wrong...." ); 
		})
        .finally( () => this.state$.setLoading(false));
        
        //When duplicating for Student, load account list for sharing
        if( this.accountType == "Student") {
        	this.contentService.getAccountsListForShare({shareWithoutAccessOnly: true, ignoreStudentAccounts: true, ignoreAdminAccounts: false}).then( (response)=>{
				this.districtAccounts = response.data.accountsWithoutAccess;
				
				this.shareRequiredForStudent = true;
			});
        }
	}
	
	public onCreateNewFolder = () => {
	    this.state$.setLoading(true);
	    
		if(this.state$.newFolderName){
		    this.contentService.createFolder( 
		        this.state$.newFolderName, 
		        this.lesson ? FolderTypes.Lesson : FolderTypes.Portfolio 
		    )
    		.then( result => {
    			if(result?.data){
    				if(result?.successfulActions?.length && result.data){
    					this.state$.folders.push(result.data);
    				}
    				this.state$.showCreateNewFolder = false;
		            this.state$.setLoading(false);
    			}
    		})
    		.catch( e => {
    	        this.$log.error(e);
    	        this.state$.setError(true, e?.message || e?.data?.message || "Something went wrong...." ); 
    		})
            .finally( () => this.state$.setLoading(false));
		}
	}
	
	public onSelectFolder = ( folder ) => {
		this.state$.selectedFolder = folder;
	}
	
	public onDuplicate = () => {
	   
	   //Set confirmation message for confirm dialog box
		let confirmationMessage = "";
	    if( this.lesson ){
    	    confirmationMessage = `Save Lesson ${this.lesson?.title } as ${this.state$.title}`;
        }
        else if( this.portfolio ){
        	confirmationMessage = `Save Portfolio ${this.portfolio?.title } as ${this.state$.title}`;
        }
        
        if(this.state$.selectedFolder?.folderID) {
        	confirmationMessage += ` into Folder ${this.state$.selectedFolder.title } ?`;
        } else {
        	confirmationMessage += ` ?`;
        }
        
        this.state$.setShowConfirmDialog(
            true,  confirmationMessage 
    	);
	}
	
	public onActionConfirmed = (confirm:boolean) => {
        
        this.state$.setShowConfirmDialog(false);
        
        if(confirm){
            this.lesson ? this.duplicateLesson() : this.duplicatePortfolio();
        } 
    }
	
	private duplicateLesson = () => {
		this.state$.setLoading(true);
	    this.state$.setError(false);
	    
        this.lessonService
        .duplicateLesson(this.lesson.lessonID, this.state$.title, this.state$.selectedFolder?.folderID)
        .then( res => {
            if(!res?.data?.lessonID){ throw res}
            
            this.state$.newLessonOrPortfolioURL = `/lesson-editor/?lessonID=${res.data.lessonID}&view=edit`;
            let confirmationMessage = `Lesson ${this.state$.title} has been successfully saved`;
            if(this.state$.selectedFolder?.folderID) {
	        	confirmationMessage += ` into Folder ${this.state$.selectedFolder.title }.`;
	        }
            this.state$.setSuccess(
	            true,  confirmationMessage
	        );
        })
        .catch( e => {
	        this.$log.error(e);
	        this.state$.setError(true, e?.message || e?.data?.message || "Something went wrong...." ); 
		})
        .finally( () => this.state$.setLoading(false));
	}
	
	private duplicatePortfolio = () => {
		this.state$.setLoading(true);
	    this.state$.setError(false);
	    
	    this.portfolioService
        .duplicatePortfolio(this.portfolio.portfolioID, this.state$.title, this.state$.selectedFolder?.folderID, this.portfolioFacultyAccount)
        .then( res => {
            if(!res?.data?.portfolioID){ throw res}
            
            this.state$.newLessonOrPortfolioURL = `/portfolio-editor/?portfolioID=${res.data.portfolioID}&view=edit`;
            let confirmationMessage = `Portfolio ${this.state$.title} has been successfully saved`;
            if(this.state$.selectedFolder?.folderID) {
	        	confirmationMessage += ` into Folder ${this.state$.selectedFolder.title }.`;
	        }
            this.state$.setSuccess(
	            true,  confirmationMessage
	        );
        })
        .catch( e => {
	        this.$log.error(e);
	        this.state$.setError(true, e?.message || e?.data?.message || "Something went wrong...." ); 
		})
        .finally( () => this.state$.setLoading(false));
	}
	
	
    public getMyFolders = () : ng.IPromise<FoldersAPIResponse>  => {
		if( this.lesson ){
			return this.lessonService.getMyLessonFolders({ showAll: true, ignoreArchiveFolder: true })
		}
		else if( this.portfolio ){
		    return this.portfolioService.getMyPortfolioFolders({ showAll: true, ignoreArchiveFolder: true })
		}
	}
	
	
	private closeModal = () => {
		this.close(this.state$.hasSuccess);
	};
    
}

class DuplicateModal {
	public restrict: string = 'E';
	public scope:{};
	
	public bindToController = {
	    lesson:'<',
	    portfolio:'<',
	    close:'=',
	    actionType: '<',
	    accountType: '<'
	};

	public controller = DuplicateModalController;
	public controllerAs = 'duplicateModal';
	
	public templateUrl = __DAVIS_FRONTEND_BASE_PATH__ + '/davisdigital/directives/modals/duplicate-modal.html';

	public static Factory() {
		return () => new this();
	}
}

export {DuplicateModal};
